import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Flex,
  Input,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { api } from '../../../../../services/api'
import { useQuery } from 'react-query'

async function getCategorySite() {
  const response = await api.get('/site/v2/detalhes-produto/listar-categorias')

  return response.data.sort((a, b) => a.descricao_categoria.localeCompare(b.descricao_categoria))
}


export const MenuCategoria = ({ onSelectedCategory, category }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  
  const [query, setQuery] = useState('')

  const { data: categorias, isLoading } = useQuery({
    queryKey: 'category-site',
    queryFn: getCategorySite,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24
  })
  const [filteredCategories, setFilteredCategories] = useState(categorias)
  

  const handleFilterCategories = () => {
    const value = query

    if (value === '') {
      setFilteredCategories(categorias)
    }

    if (value.length > 2) {
      const filtered = categorias.filter((category) => category.descricao_categoria.toLowerCase().includes(value.toLowerCase()))
      setFilteredCategories(filtered)
    }

    
  }

  function handleSelectedCategory(category) {
    onSelectedCategory(category)
    onClose()
  }

  useEffect(() => {
    handleFilterCategories()
  }, [query, onOpen])

  useEffect(() => {
    setQuery('')
  }, [isOpen])


  return (
    <>
      <Button 
        onClick={onOpen}
        colorScheme='green'
      >
        {category ? category : 'Selecione uma categoria'}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Selecione uma Categoria</ModalHeader>
          <ModalCloseButton />
          <ModalBody
            display='grid'
            gridTemplateColumns='repeat(3, 1fr)'
            gap={4}
            maxH='500px'
            overflowY='auto'

          >
            <Flex
              gridColumn='1 / 4'
              justifyContent='center'
              mb={4}
            >
              <Input
                placeholder='Pesquise uma categoria'
                onChange={(e) => setQuery(e.target.value)}
              />
            </Flex>


            {filteredCategories?.map((category) => (
              <Button 
                key={category.codigo_grupo} 
                variant='outline' 
                colorScheme='blue'
                onClick={() => handleSelectedCategory(category)}
              >
                {category.descricao_categoria}
              </Button>
            ))}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button variant='ghost'>Confirmar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}